<template>
  <div class="footer">
    <div class="container">
      <div class="foot_content">
        <!-- <div class="flex_center flex_between"> -->
        <div class="l">
          <div class="l_top">
            <img
              class="foot_logo"
              src="https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/foot_logo.png"
              alt=""
            />
            <button class="btn_contactUs" @click="isContactUsShow = true">
              <i class="icon_mail" />联系我们
            </button>
          </div>
          <div class="ctu">
            <!-- <i class="icon_email"></i>联系我们：service@chrivc.cn -->

            <div class="copyright">
              Copyright©2022 |
              <a
                href="https://beian.miit.gov.cn/#/Integrated/index"
                target="_blank"
                style="color: #b9b9b9;
            text-decoration: none;"
                >蜀ICP备2022002824号</a
              >
              <router-link
                to="/agreement"
                style="color: #b9b9b9;cursor:pointer;
            text-decoration: none;"
                target="_blank"
                >《用户协议》</router-link
              >
              <router-link
                to="/private"
                style="color: #b9b9b9;cursor:pointer;
            text-decoration: none;"
                target="_blank"
                >《隐私政策》</router-link
              >
            </div>
          </div>
        </div>
        <div class="r">
          <p class="pfM">全国产品防伪溯源验证公共平台</p>
          <p class="en">
            China Product Anti-counterfeiting Traceability Verification Public
            Platform
          </p>
          <p class="pfM">成都德锋创享科技有限公司</p>
          <p class="en">Defshare Technology Co., Ltd.</p>
        </div>
        <!-- </div> -->
      </div>
    </div>
    <div class="friendLinks">
      <div class="container">
        <span class="linkTitle">友情链接：</span>
        <!-- <a href="https://www.samr.gov.cn/" target="_blank"
          ><i class="icon_gh"></i>中华人民共和国国家市场监督管理总局</a
        > -->
        <a href="http://www.ctaac.org.cn/" target="_blank"
          ><i class="icon_cta"></i>中国防伪行业协会</a
        >
        <a href="https://baike.baidu.com/item/%E5%85%A8%E5%9B%BD%E4%BA%A7%E5%93%81%E9%98%B2%E4%BC%AA%E6%BA%AF%E6%BA%90%E9%AA%8C%E8%AF%81%E5%85%AC%E5%85%B1%E5%B9%B3%E5%8F%B0/20135960?fr=aladdin">全国产品防伪溯源验证公共平台</a>
      </div>
    </div>
    <DialogContactUs :isShow="isContactUsShow" @handleClose="handleCtuClose" />
  </div>
</template>

<script>
import DialogContactUs from "@/components/DialogContactUs.vue";
export default {
  components: { DialogContactUs },
  data() {
    return {
      isContactUsShow: false
    };
  },
  methods: {
    handleCtuClose() {
      console.log("handleCtuClose");
      this.isContactUsShow = false;
    }
  }
};
</script>

<style scoped lang="scss">
.footer {
  // padding: 43px;
  // display: flex;
  width: 100%;
  display: inline-block;
  flex-direction: column;
  .foot_content {
    padding: 37px 0;
    display: flex;
    align-content: center;
    justify-items: center;
    justify-content: space-between;
    .l {
      .l_top {
        display: flex;
        align-items: center;
        .btn_contactUs {
          cursor: pointer;
          width: 96px;
          height: 28px;
          background: #ffffff;
          border: 1px solid #3a61b1;
          border-radius: 4px;
          font-size: 14px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #3a61b1;
          margin-left: 33px;
          display: flex;
          align-items: center;
          justify-content: center;
          .icon_mail {
            display: inline-block;
            background: url("../assets/icon_mail.png") no-repeat;
            background-size: cover;
            width: 13px;
            height: 13px;
            margin-right: 6px;
          }
        }
      }
      .ctu {
        margin-top: 20px;
        color: #6e6e6e;
        padding-right: 130px;
        .copyright {
          color: #b9b9b9;
          margin-top: 15px;
        }
      }
    }
    .pfM {
      font-family: "PingFang MEDIUMS";
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #6e6e6e;
    }
    .r {
      text-align: right;
      color: #6e6e6e;
      .en {
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #a2a2a2;
        &:not(:last-child) {
          margin-bottom: 17px;
        }
      }
    }
  }
  .friendLinks {
    height: 51px;
    background: #eeeeee;
    display: flex;
    align-items: center;
    .linkTitle {
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #6e6e6e;
      margin-right: 7px;
    }
    a {
      font-size: 12px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #8d8d8d;
      margin-right: 30px;
      text-decoration: none;
      .icon_gh {
        width: 15px;
        height: 17px;
        display: inline-block;
        background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/gh.png")
          no-repeat;
        background-size: 100%;
        vertical-align: bottom;
        margin-right: 6px;
      }
      .icon_cta {
        width: 21px;
        height: 17px;
        display: inline-block;
        background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/cta.png")
          no-repeat;
        background-size: 100%;
        vertical-align: bottom;
        margin-right: 3px;
      }
    }
    .more {
      font-size: 12px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #5673b0;
      float: right;
      cursor: pointer;
    }
  }
  // .container {
  //   .l {
  //     .ctu {
  //       margin-top: 20px;
  //       color: #6e6e6e;
  //       padding-right: 130px;
  //       .copyright {
  //         color: #b9b9b9;
  //         margin-top: 15px;
  //       }
  //     }
  //   }
  //   .r {
  //     text-align: right;

  //     color: #6e6e6e;
  //     .en {
  //       margin-top: 3px;
  //       color: #a2a2a2;
  //       &:not(:last-child) {
  //         margin-bottom: 17px;
  //       }
  //     }
  //   }
  // }
}
.foot_logo {
  width: 234px;
  height: 45px;
}

// .copyright {
//   color: #b9b9b9;
//   margin-top: 16px;
// }
.icon_tel {
  background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/icon_tel.png")
    no-repeat;
  width: 13px;
  height: 13px;
  display: inline-block;
  background-size: 100%;
  margin-right: 15px;
}
.icon_email {
  background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/icon_email.png")
    no-repeat;
  width: 13px;
  height: 13px;
  display: inline-block;
  background-size: 100%;
  margin-right: 15px;

  //   margin-left: 38px;
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue